import { render, staticRenderFns } from "./IconSectionFeatured.vue?vue&type=template&id=1ad446dd&"
import script from "./IconSectionFeatured.vue?vue&type=script&lang=js&"
export * from "./IconSectionFeatured.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad446dd')) {
      api.createRecord('1ad446dd', component.options)
    } else {
      api.reload('1ad446dd', component.options)
    }
    module.hot.accept("./IconSectionFeatured.vue?vue&type=template&id=1ad446dd&", function () {
      api.rerender('1ad446dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSectionFeatured.vue"
export default component.exports